import { action, computed, makeObservable, observable } from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import Feature from "../../Feature";
import errorToast from "../../../components/toast/ErrorToast";
import DashboardDateRangeValidity from "../DashboardDateRangeValidity";

export default class SalesByArticleCategoryFeature extends Feature {
    constructor(application, filters) {
        super(application);
        this._filters = filters;
        this._salesByArticleCategory = null;

        makeObservable(this, {
            _salesByArticleCategory: observable,
            salesByArticleCategory: computed,
            setSalesByArticleCategory: action,
        });
    }

    async load() {
        if (!DashboardDateRangeValidity.isValid(this._filters.fromDate, this._filters.toDate)) {
            return;
        }
        await this._getSalesByArticleCategory();
        this.finishLoading();
    }

    setSalesByArticleCategory(data) {
        this._salesByArticleCategory = data;
    }

    get salesByArticleCategory() {
        return this._salesByArticleCategory;
    }

    async _getSalesByArticleCategory() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this.setSalesByArticleCategory(response.salesByArticleCategory());
            },
            handlesError: () => {
                errorToast("No se pudieron obtener las ventas por categoría");
                this.setSalesByArticleCategory({ rows: [], total: null });
            },
        });
        return this._application.apiClient().getSalesByArticleCategory(responseHandler, this._filters.fromDate,
                                                                       this._filters.toDate, this._filters.channels,
                                                                       this._filters.articleCategories,
                                                                       this._filters.withoutAllowances);
    }
}
